/* SLIDE 36 */

import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ButtonBot from "shared/components/ButtonBot";
import SubHeader from "shared/components/SubHeader";
import AppInput from "shared/components/AppInput";
import AppSelect from "shared/components/AppSelect";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";

const UserManagerEdit = () => {
  const { register, handleSubmit, setValue, watch, formState: { errors } } = useForm();
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  const navigation = useNavigate();
  const location = useLocation();
  const [type, setType] = useState("사용자 구분");
  const [addressValue, setAddressValue] = useState("");
  const [showInputaddress, setShowInputaddress] = useState(false);

  const onNavi = (path) => {
    navigation(path);
  };

  useEffect(() => {
    // Set the initial value for the car number input field
    user && setValue("userId", user.userId || '', { shouldValidate: true });
    user && setValue("name", user.name || '', { shouldValidate: true });
  }, [user]);

  const handleSelectChange = (e) => {
    const option = e;
    setType(e);
    if (option == "근무자") {
      setShowInputaddress(true);
    } else {
      setShowInputaddress(false);
    }
  };

  const changeInputValue = () => {
    if (addressValue == "") {
      setAddressValue("새마을시장주차장 (01-002)");
    } else {
      setAddressValue("");
    }

  }

  const getCurrentDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const handleLogin = (data) => {
    console.log("Form submitted:", data);
    // Perform login action here
  }

  const onError = (error) => {
    console.log("Form error:", error);
  }

  return (
    <div className="parking-status-container">
      <SubHeader>
        <div className={`sub-header-text w-full`}>
          <span className="htBold">사용자 정보</span>
        </div>
      </SubHeader>
      <form onSubmit={handleSubmit(handleLogin, onError)} className="htContent pt-20 pb-80 mn-content-edit-user-address">
        <AppInput
          className="htBold"
          label="사용자명"
          placeholder="민길동"
          register={register("name", {
            required: {
              value: true,
              message: '이름을 입력해주세요.'
            },
          })}
          error={errors.name}
        />

        <AppInput
          className="htBold"
          label="사용자ID"
          placeholder="사용자ID"
          value={user.userId}
          readonlyInput="true" />

        <AppInput
          className="htBold"
          label="전화번호"
          placeholder="전화번호"
          register={register("mobilePhone")}
        />


        {/* <AppInput
          className="htBold"
          label="비밀번호"
          placeholder="비밀번호 초기화"
        /> */}
        {/* 
        <AppSelect
          label="사용자 구분"
          options={[
            { value: "사용자 구분", label: "사용자 구분" },
            { value: "근무자", label: "근무자" },
          ]}
          onChange={(e) => handleSelectChange(e.target.value)}
          value={type}
        ></AppSelect> */}

        {/* 
        {showInputaddress && (
          <div className="form-group">
            <label>근무지 설정</label>
            <div className="address-input">
              <input type="text" defaultValue={addressValue} placeholder="근무지 설정" />
              <button className="search-button-input" onClick={changeInputValue}>찾아보기</button>
            </div>
          </div>
        )} */}

        {/* <AppInput
          className="htBold"
          label="비밀번호"
          placeholder="개인정보 이용 동의 후 수및 수정가능"
        /> */}

        <div className="form-group">
          <div className="notice-content" style={{ borderRadius: "6px" }}>
            <div className="notice-text-content">
              <label>*사용자ID</label>
              <div className="notice-text-content-description">
                <p>- 영문 대소문자, 특수문자(-,_) 사용가능 </p>
                <p>- 공백 금지 </p>
                <p>- 이미 사용중인 ID 생성 불가</p>
              </div>

              <label>*비밀번호</label>
              <div className="notice-text-content-description">
                <p>- 영문, 숫자를 혼합하여 6~10자 이내</p>
              </div>
            </div>
          </div>
        </div>

        <ButtonBot
          textYes={"저장하기"}
          // textNo={"취소하기"}
          // handleNo={() => onNavi("/menu_manager")}
          typeYes="submit"
        />
      </form>
    </div>
  );
};

export default UserManagerEdit;
